import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Building, Handshake, ArrowRight } from 'lucide-react';

const audience = [
  { icon: Compass, label: 'Architectes & maîtres d\'œuvre' },
  { icon: Building, label: 'Syndics & gestionnaires' },
  { icon: Handshake, label: "Agents immobiliers & apporteurs d'affaires" },
];

const PartnersTeaser = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div
          data-testid="partners-teaser"
          className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-emerald-600 to-cyan-600 p-8 md:p-14"
        >
          <div className="absolute -top-16 -right-10 w-72 h-72 bg-white/10 rounded-full blur-2xl" />
          <div className="relative z-10 grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="text-emerald-50/90 font-semibold text-sm uppercase tracking-wider mb-3 block">
                Pros & Partenaires
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Vous avez une affaire à nous confier ?
              </h2>
              <p className="text-lg text-emerald-50/90 leading-relaxed mb-6">
                Architectes, syndics, maîtres d'œuvre, professionnels de l'immobilier et apporteurs
                d'affaires : transmettez-nous votre dossier (plans, CCTP, DPGF, photos) en quelques clics.
                Étude et chiffrage par notre équipe.
              </p>
              <Link
                to="/partenaires-professionnels"
                data-testid="partners-teaser-cta"
                className="inline-flex items-center gap-2 bg-white text-emerald-700 hover:text-emerald-800 px-7 py-3.5 rounded-lg font-semibold transition-all hover:gap-3"
              >
                Transmettre une affaire <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
            <div className="grid gap-4">
              {audience.map((a, i) => {
                const Icon = a.icon;
                return (
                  <div key={i} className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl px-5 py-4 border border-white/15">
                    <div className="w-11 h-11 bg-white/15 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Icon className="h-5 w-5 text-white" />
                    </div>
                    <span className="text-white font-medium">{a.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersTeaser;
